import ManageTagsPage from './ManageTagsPage';

export default ManageTagsPage;
